/**
 * SSOT-71 / #10189 — header counts genuine requirements separately from guidance.
 */

export type MandateLevelReq = {
  mandate_level?: string | null;
  mandateLevel?: string | null;
};

export function normalizeMandateLevel(req: MandateLevelReq): string {
  return String(req.mandate_level ?? req.mandateLevel ?? "")
    .trim()
    .toLowerCase();
}

export function isGuidanceRequirement(req: MandateLevelReq): boolean {
  const level = normalizeMandateLevel(req);
  return level === "recommended" || level === "optional" || level === "guidance";
}

export function isMandatoryRequirement(req: MandateLevelReq): boolean {
  const level = normalizeMandateLevel(req);
  // Treat missing mandate as mandatory (named cards default).
  return !level || level === "mandatory" || level === "required";
}

export function formatFederalRequirementsHeaderCount(
  federalCards: MandateLevelReq[],
  cfrSectionCount: number,
): string {
  const mandatory = federalCards.filter(isMandatoryRequirement).length;
  const guidance = federalCards.filter(isGuidanceRequirement).length;
  const requirements = mandatory + Math.max(0, Number(cfrSectionCount) || 0);
  if (guidance > 0) {
    return `${requirements} requirements, ${guidance} guidance`;
  }
  return `${requirements}`;
}
